<template>
  <div class="echarts12">
    <div class="bigbox">
      <div class="piler" v-for="(item,index ) in health" :key="index">
        <div style="margin:0 0 6 0">{{item.facility}}</div>
        <el-progress :stroke-width="numb" :percentage="item.msg"></el-progress>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: "echarts12",
  props: {
    health: {
      type: Array,
      default: () => {
        return [
          { facility: "堆垛机", msg: 60.7 },
          { facility: "提升机", msg: 38.8 },
          { facility: "夹抱机", msg: 80 }
        ];
      }
    }
  },
  data() {
    return {
      numb:15
    };
  }
};
</script>
<style scoped>
.echarts12 {
  width: 319px;
  height: 218px;
  text-align: left;
  color: #338A6A;
  position: relative;
  margin-top: 46px;
  margin-left: 40px;
}
.bigbox {
    height: 165px;
    width: 280px;
    position: absolute;
    bottom: 0;
    right: 20px;
}
.piler {
    margin-bottom: 14px;
    font-size: 14px;
    font-weight: 500
}
.echarts12 >>> div.el-progress-bar__inner {
  background-color: #8ad9fa !important;
  background-image: linear-gradient(to right, #DAD0B7, #C7AE75);
  border-radius: 3px;
}
.echarts12 >>> .el-progress-bar__outer {
  border-radius: 3px;
  background-color: #F8F5F0;
}
.echarts12 >>> .el-progress__text {
    color: #338A6A;
    font-size: 16px !important;
    width: 30px
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts2.vue